import store from '@/store'

export default function usePermission() {

    /**
     * 权限判断
     * @param {*} permission 
     * @returns 
     */
    function hasPermission(permission) {
        //读取缓存中的数据
        let operation = store.state.operation
        if (operation) {
            operation = Array.isArray(operation) ? operation : operation.split(',')
            if (operation.indexOf(permission) > -1) {
                return true;
            }
        }
        return false;
    }
    return {
        hasPermission
    };
}